export default __webpack_public_path__ + "static/media/selo.0496ba8f.png";